<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
            letter-spacing: 2px;
          "
        >
          特色功能
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
          <li class="pli">
            <div v-bind:class="[form.fourteenth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.fourteenth ? class1 : class5]"
              @click="fourteenth"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">算法分批下单</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
            ></div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.thirteenth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.thirteenth ? class1 : class5]"
              @click="thirteenth"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">下单任务管理器</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.fourteenth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.twlfth ? class4 : class3]"></div>
            <div v-bind:class="[form.twlfth ? class1 : class5]" @click="twlfth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">网格交易运行池</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.thirteenth"
              />
            </div>
          </li>
           <li class="pli">
            <div v-bind:class="[form.fifteenth ? class4 : class3]"></div>
            <div v-bind:class="[form.fifteenth ? class1 : class5]" @click="fifteenth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">文件下单</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.twlfth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.twoth ? class4 : class3]"></div>
            <div v-bind:class="[form.twoth ? class1 : class2]" @click="twoth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">扩展分析</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.fifteenth "
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.threeth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.threeth ? class1 : class2]"
              @click="threeth"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid" style="width: 145px">k线图叠加现货数据</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.twoth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.oneth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.oneth ? class1 : class5]"
              style="line-height: 15px"
              @click="oneth"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid" style="padding-top: 5px">
                k线查价同时可看历史信息解读
              </div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>

            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.threeth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fourth ? class4 : class3]"></div>
            <div v-bind:class="[form.fourth ? class1 : class2]" @click="fourth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">云端趋势线预警</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.oneth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fiveth ? class4 : class3]"></div>
            <div v-bind:class="[form.fiveth ? class1 : class2]" @click="fiveth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">云端公式预警</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.fourth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.sixth ? class4 : class3]"></div>
            <div v-bind:class="[form.sixth ? class1 : class2]" @click="sixth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">一机多屏</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.fiveth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.seventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.seventh ? class1 : class2]"
              @click="seventh"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">页面内存驻留</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.sixth"
              />
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.eleventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.eleventh ? class1 : class6]"
              @click="eleventh"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">股票相关特色功能</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div style="width: 9px; height: 7px; float: left; ine-height: 7px">
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
                v-if="form.seventh"
              />
            </div>
          </li>
          <li class="pli">
            <div
              style="width: 10px; height: 7px; float: right; ine-height: 7px"
              v-if="form.eleventh"
            >
              <img
                src="../../assets/images/lan-jia.png"
                style="display: block"
              />
            </div>
          </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="form.fourteenth">
              <h4 class="head4" id="productcenterfourteen">一、算法分批下单</h4>
              <p class="pproduct">
                算法分批下单内置多种经典算法交易策略，可自动监控行情变化、委托回报等交易信息，加强对交易过程的精细化控制，实现智能分批，达到减少成交滑点，提高交易效率的目的。
              </p>
              <p class="pproduct">
                如下图所示，睿期wh7封装了八个经典算法交易策略（<a
                  href="https://www.wenhua.com.cn/popwin/7sfjy.htm"
                  class="eeee"
                  target="_blank"
                  >点击查看算法策略说明</a
                >），只需填写参数即可使用策略。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/sfjy.jpg" />
              </p>
            </div>
            <div v-if="form.thirteenth">
              <h4 class="head4" id="productcenterthirteen">
                二、下单任务管理器
              </h4>
              <p class="pproduct">
                添加多个下单任务，让软件自动监控价格，符合价格条件时自动执行下单任务，交易员只需关注交易日志和任务执行进度。
              </p>
              <!-- <h5 class="head5">智能分批降低冲击成本</h5> -->
              <p class="pproduct">
                下单任务管理器可智能分批降低冲击成本，根据不同合约的活跃程度，设定每批下单手数，在确保不破坏趋势的前提下，提高成交效率。同时还可添加偏离条件，当价格偏移过大时暂停交易，价格回归以后自动继续下单，以确保所有订单成交在相同的价格附近。
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/jyrw2.jpg" width="530" />
              </p>
            </div>
            <div v-if="form.twlfth">
              <h4 class="head4" id="productcentertwlf">三、网格交易运行池</h4>
              <p class="pproduct">
                网格策略适用于震荡行情，启动后可自动循环执行高抛低吸买卖操作。
              </p>
              <p class="pproduct">网格交易运行池提供以下两种网格策略：</p>
              <h5 class="head5">1、单向网格策略</h5>
              <p class="pproduct">
                策略算法：
              </p>
              <p class="pproduct">以震荡向上行情做多为例：首次开仓需手动委托（启动网格策略），开多成交后自动以成交价/委托价+M点挂出平多委托，等待高抛；高抛成交后，自动以平仓成交价/委托价-N点挂出开多委托，等待低吸；如此循环。M、N、循环次数均可设置。</p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wgcl1.png" />
              </p>
              <!-- <p class="pproduct" style="text-align: center; font-size: 13px">
                震荡向上行情网格策略执行效果示意图
              </p> -->
              <h5 class="head5">2、固定网格策略</h5>
              <p class="pproduct">
                策略算法：
              </p>
              <p class="pproduct">
                点击“启动”按钮，软件以最新价为基准，在最新价上下发出渔网式委托，即在最新价之上和之下同时发出M笔买开和M笔卖开委托，每笔委托价差间隔(Q)相同、委托手数相同；
              </p>
              <p class="pproduct">
                等待行情变动，当挂出去的任意一笔开仓委托成交后，软件会自动挂出Q点盈利的止盈委托单，等待盈利收网；止盈成交后，自动在原开仓价位重新挂出开仓委托，重新补网。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wg-2.jpg" width="530px"/>
              </p>
              <p class="pproduct" style="padding-top:25px">
                网格交易运行池支持多个期货合约或套利合约同时进行网格策略交易，支持批量监控、批量删除。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <img src="@/../public/proimg/wg-3.jpg"  width="530px"/>
              </p>
            </div>
            <div v-if="form.fifteenth">
              <h4 class="head4" id="productcenterfifteen">四、文件下单</h4>
              <p class="pproduct">
                使用文件下单功能可以快速将Excel 或 Python 等文件生成 csv 格式交易指令转变为账户持仓。系统自动扫描文件发送委托、控制下单间隔，方便、快速、准确。
              </p>
              <p class="pproduct">
                使用步骤如下图所示：
              </p>
              <p class="pimg"><img src="@/../public/proimg/wjxd2.jpg" /></p>
            </div>
            <div v-if="form.twoth">
              <h4 class="head4" id="productcentertwo">五、扩展分析</h4>
              <p class="pproduct">
                回归分析：根据K线图数据精确计算合约的相关性和线性关系，并提供散点图、回归方程、Beta、Alpha、R^2等专业统计指标，以进行价格预测、套利可行性检验等分析；
              </p>
              <p class="pproduct">
                波动率分析：基于历史数据统计短期和长期波动率指标，假设未来是历史的延伸，利用历史估计未来价格波动率，判断交易机会；
              </p>
              <p class="pproduct">
                季节性分析：按月记录合约价格趋势和涨幅并逐年横向对比，研究商品的周期性，掌握合约价格波动周期，提前部署交易计划；
              </p>
              <p class="pproduct">
                期货横截面：由不同交割月份合约的价格按照到期时间先后串联组成远期价格曲线，反应合约远期价格趋势。
              </p>
              <p class="pproduct">
                期现链：提供现货历史价格走势和距离交割日不同周期的价格点位标记，直观分析何时入场持有到期更加合理。
              </p>
            </div>
            <div v-if="form.threeth">
              <h4 class="head4" id="productcenterthree">
                六、k线图叠加现货数据
              </h4>
              <p class="pproduct">
                连续的现货数据线形展示，与相同品种期货K线叠加，让期现价差一目了然。
              </p>
              <p class="pproduct">
                提供的现货数据包括：国内主要现货市场价格、全球品种供需数据、国家海关进出口数据、国内外交易所库存、CFTC统计的持仓数据。
              </p>
              <p class="pimg"><img src="@/../public/proimg/djxhsj.jpg" /></p>
            </div>
            <div v-if="form.oneth">
              <h4 class="head4" id="productcenterone">
                七、K线查价同时可看历史信息解读
              </h4>
              <p class="pproduct">
                对于异动K线（大涨/跌、大跳空、长上下影线）可见历史信息解读。
              </p>
              <p class="pimg"><img src="@/../public/proimg/111.jpg" /></p>
            </div>
            <div v-if="form.fourth">
              <h4 class="head4" id="productcenterfour">八、云端趋势线预警</h4>
              <p class="pproduct">
                画线分析后不必盯盘，价格碰触趋势线自动预警。电脑关机状态下，当满足触发条件时可在手机上收到预警。
              </p>
              <p class="pproduct">
                线型支持：趋势线、射线、水平线、线段、通道线、矩形、三角形、甘氏线、阻速线、线型回归带、回归通道、黄金率、百分比线、波浪尺、量度目标。
              </p>
              <p class="pproduct">本功能只支持国内期货合约。</p>
              <p class="pimg"><img src="@/../public/proimg/qsxyj_4.jpg" /></p>
            </div>
            <div v-if="form.fiveth">
              <h4 class="head4" id="productcenterfive">九、云端公式预警</h4>
              <p class="pproduct">
                自定义预警公式，云端存储。针对国内期货合约设置云端预警条件，当条件满足时即使电脑是关闭状态，也会在手机上收到提醒。
              </p>
              <p class="pimg"><img src="@/../public/proimg/gsyj.jpg" /></p>
            </div>
            <div v-if="form.sixth">
              <h4 class="head4" id="productcentersix">十、一机多屏</h4>
              <p class="pproduct">
                一机多屏是wh7特有的功能，可将自设页面分屏到其他多个屏幕上，同时查看更多的合约，更多的指标，更多画线分析。
              </p>
              <p class="pproduct">
                多个屏幕页面，加载多个预警公式/交易模型，自动闪屏提示，盘面信号变动一目了然。
              </p>
              <p class="pimg"><img src="@/../public/proimg/picp4-wh7.png" /></p>
            </div>
            <div v-if="form.seventh">
              <h4 class="head4" id="productcenterseven">十一、页面内存驻留</h4>
              <p class="pproduct">
                自设页面驻留内存，切换页面不需要再申请数据，瞬间完成。
              </p>
              <p class="pimg"><img src="@/../public/proimg/ymqh4.gif" /></p>
              <!-- <h4 class="head4" id="productcentereight">十、F9商品深度资料</h4>
            <p class="pproduct">
              以图表形式展现品种产业链涉及的所有基本面数据走势，包括国家统计局的供需数据、国家海关进出口数据、CFTC的持仓数据、国内外交易所库存数据、国内主要现货市场现货价格、机构观点、国内外指数对比图及合约相关股票列表。
            </p>
            <p class="pimg"><img src="@/../public/proimg/sdzl.png" /></p> -->
            </div>
            <div v-if="form.eleventh">
              <h4 class="head4" id="productcentereleven">
                十二、股票相关特色功能
              </h4>
              <p class="pproduct">
                股票板块地图：按行业和地域分类显示板块地图，可直观观察板块涨跌。
              </p>
              <p class="pproduct">
                公式选股：在全市场范围内，根据K线形态、指标、盘面行情、财务数据等数据，选出满足条件的股票。
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        oneth: false,
        twoth: false,
        threeth: false,
        fourth: false,
        fiveth: false,
        sixth: false,
        seventh: false,
        eightth: false,
        eleventh: false,
        twlfth: false,
        thirteenth: false,
        fourteenth: true,
        fifteenth:false,
      },
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
      scroll: "",
    };
  },
  methods: {
    custormAnchor(anchorName) {
      // // 找到锚点
      // let anchorElement = document.getElementById(anchorName);
      // // 如果对应id的锚点存在，就跳转到锚点
      // if(anchorElement) { anchorElement.scrollIntoView(); }

      // var s = anchorName.split("productcenter")[1];
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.form[anchorName.split("productcenter")[1] + "th"] = true;
      // target.parentNode.scrollTop = target.offsetTop;
      // this.$refs.box.scrollTop = target.offsetTop;
    },
    oneth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.oneth = true;
      var id = "productcenterone";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    twoth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twoth = true;
      var id = "productcentertwo";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    threeth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.threeth = true;
      var id = "productcenterthree";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    fourth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourth = true;
      var id = "productcenterfour";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    fiveth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fiveth = true;
      var id = "productcenterfive";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    sixth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.sixth = true;
      var id = "productcentersix";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    seventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.seventh = true;
      var id = "productcenterseven";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    eightth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eightth = true;
      var id = "productcentereight";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    eleventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eleventh = true;
      var id = "productcentereleven";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },

    twlfth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twlfth = true;
      var id = "productcentertwlf";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    thirteenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.thirteenth = true;
      var id = "productcenterthirteen";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    fourteenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourteenth = true;
      var id = "productcenterfourteen";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    fifteenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fifteenth= true;
      var id = "productcenterfifteen";
      this.$router.push({ path: `/proc/productcenter/${id}` });
      //this.custormAnchor(id);
    },
    zero() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
    },

    menu(e) {
      if (
        e.target.scrollTop >=
          document.querySelector("#productcenterfourteen").offsetTop &&
        document.querySelector("#productcenterthirteen").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.fourteenth = true;
        var id13 = "productcenterfourteen";
        this.$router.push({ path: `/proc/productcenter/${id13}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterthirteen").offsetTop &&
        document.querySelector("#productcentertwlf").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.thirteenth = true;
        var id14 = "productcenterthirteen";
        this.$router.push({ path: `/proc/productcenter/${id14}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcentertwlf").offsetTop &&
        document.querySelector("#productcentertwo").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.twlfth = true;
        var id12 = "productcentertwlf";
        this.$router.push({ path: `/proc/productcenter/${id12}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcentertwo").offsetTop &&
        document.querySelector("#productcenterfifteen").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.fifteenth = true;
        var id1 = "productcenterfifteen";
        this.$router.push({ path: `/proc/productcenter/${id1}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterfifteen").offsetTop &&
        document.querySelector("#productcenterthree").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.twoth = true;
        var id1 = "productcentertwo";
        this.$router.push({ path: `/proc/productcenter/${id1}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterthree").offsetTop &&
        document.querySelector("#productcenterone").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.threeth = true;
        var id2 = "productcenterthree";
        this.$router.push({ path: `/proc/productcenter/${id2}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterone").offsetTop &&
        document.querySelector("#productcenterfour").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.oneth = true;
        var id3 = "productcenterone";
        this.$router.push({ path: `/proc/productcenter/${id3}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterfour").offsetTop &&
        document.querySelector("#productcenterfive").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.fourth = true;
        var id4 = "productcenterfour";
        this.$router.push({ path: `/proc/productcenter/${id4}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenterfive").offsetTop &&
        document.querySelector("#productcentersix").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.fiveth = true;
        var id5 = "productcenterfive";
        this.$router.push({ path: `/proc/productcenter/${id5}` });
      }
      // else if (
      //   e.target.scrollTop >=
      //     document.querySelector("#productcentersix").offsetTop &&
      //   document.querySelector("#productcenterseven").offsetTop >
      //     e.target.scrollTop
      // ) {
      //   this.zero();
      //   this.form.sixth = true;
      //   var id6 = "productcentersix";
      //   this.$router.push({ path: `/proc/productcenter/${id6}` });
      // }
      //           else if(e.target.scrollTop>=document.querySelector("#productcenterten").offsetTop && document.querySelector("#productcentereleven").offsetTop>e.target.scrollTop ){

      //            this.zero()
      // this.form.tenth=true
      // }
      else {
        if (this.form.eleventh == true) {
          this.zero();
          this.form.eleventh = true;
          var id11 = "productcentereleven";
          this.$router.push({ path: `/proc/productcenter/${id11}` });
        } else if (this.form.seventh == true) {
          this.zero();
          this.form.seventh = true;
          var id7 = "productcenterseven";
          this.$router.push({ path: `/proc/productcenter/${id7}` });
        } else {
          this.zero();
          this.form.sixth = true;
          var id6 = "productcentersix";
          this.$router.push({ path: `/proc/productcenter/${id6}` });
        }
      }
    },
  },

  mounted() {
    this.custormAnchor(this.$route.params.id);
  },
};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 650px;
  border-radius: 2%;
  background: url("../../assets/images/ts-1_01.png") no-repeat center;
  background-size: 100% 100%;
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #2f5476;
  letter-spacing: 1px;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #395774;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>